import { LocationOption } from '../../location/models/location-option.interface';

export function filterLocationOption(types: LocationOption[], searchText: string | null | undefined): LocationOption[] {
   if (types.length === 0) {
      return [];
   }
   const term = searchText && searchText.trim();
   if (term) {
      const upper = term.toUpperCase();
      return types.filter((item) => {
         return (
            item?.name?.toUpperCase().includes(upper) ||
            item?.houseNumber?.toUpperCase().includes(upper) ||
            item?.directionalPrefix?.toUpperCase().includes(upper) ||
            item?.streetName?.toUpperCase().includes(upper) ||
            item?.streetNameSuffix?.toUpperCase().includes(upper) ||
            item?.directionalPostfix?.toUpperCase().includes(upper)
         );
      });
   } else {
      return types || [];
   }
}
